import {registerTemplateGraphNode} from "#template/template-node/register"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ReduceOperatorParameters} from "#template/nodes/geometry-graph/value/reduce-operator/geometry-reduce-operator-node"
import {
    GeometryReduceOperatorNode,
    geometryReduceOperatorParametersSchema,
} from "#template/nodes/geometry-graph/value/reduce-operator/geometry-reduce-operator-node"

const definition: TemplateNodeDefinition<ReduceOperatorParameters> = {
    nodeClass: "GeometryReduceOperator",
    validation: {
        parameters: geometryReduceOperatorParametersSchema,
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class GeometryReduceOperator extends GeometryReduceOperatorNode {
    public override get definition() {
        return definition
    }
}
